import { render, staticRenderFns } from "./ExamRecord.vue?vue&type=template&id=720c0b8c&scoped=true"
import script from "./ExamRecord.vue?vue&type=script&lang=js"
export * from "./ExamRecord.vue?vue&type=script&lang=js"
import style0 from "./ExamRecord.vue?vue&type=style&index=0&id=720c0b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720c0b8c",
  null
  
)

export default component.exports